// Auto generated file, do not manually modify!
// com.hotpads.admanagement.api.web.external.handler.AdManagementEliseAiApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { PropertyEliseDto } from '../..';

interface UpdateAllEliseAiStatusesParams {
  isEliseAiEnabled: boolean;
}
interface UpdateEliseAiStatusParams {
  isEliseAiEnabled: boolean;
  propertyListingAlias: string;
}

export const AdManagementEliseAiApiHandler_getEliseStatuses_Path = '/api/web/v1/eliseAiPaths/getEliseStatuses';

/**
 * Grabs all the mfh paid property thumbnails and elise statuses for a user
 */
export const AdManagementEliseAiApiHandler_getEliseStatuses = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<PropertyEliseDto>>(
    {
      endpoint: AdManagementEliseAiApiHandler_getEliseStatuses_Path,
      method: 'GET',
      contextPath: '/ad-management',
    },
    client,
  );
};

export const AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Path = '/api/web/v1/eliseAiPaths/hasEliseSfhEnabled';

/**
 * Returns if a user is part of the eliseAI SFH rollout
 */
export const AdManagementEliseAiApiHandler_hasEliseSfhEnabled = (client = getClient()) => {
  return httpFrontEndRequest<never, never, boolean>(
    {
      endpoint: AdManagementEliseAiApiHandler_hasEliseSfhEnabled_Path,
      method: 'POST',
      contextPath: '/ad-management',
    },
    client,
  );
};

export const AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Path =
  '/api/web/v1/eliseAiPaths/updateAllEliseAiStatuses';

/**
 * Queues updates for all user eliseAi statuses to chosen boolean. Tentative - Test on smaller users first! - Note: Since propertyNum can be large, doesn't queue for realtime refresh
 */
export const AdManagementEliseAiApiHandler_updateAllEliseAiStatuses = (
  getParams: UpdateAllEliseAiStatusesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UpdateAllEliseAiStatusesParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdManagementEliseAiApiHandler_updateAllEliseAiStatuses_Path,
      method: 'POST',
      contextPath: '/ad-management',
    },
    client,
  );
};

export const AdManagementEliseAiApiHandler_updateEliseAiStatus_Path = '/api/web/v1/eliseAiPaths/updateEliseAiStatus';

/**
 * Updates a given listingAlias eliseAi status
 */
export const AdManagementEliseAiApiHandler_updateEliseAiStatus = (
  getParams: UpdateEliseAiStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UpdateEliseAiStatusParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdManagementEliseAiApiHandler_updateEliseAiStatus_Path,
      method: 'POST',
      contextPath: '/ad-management',
    },
    client,
  );
};
